import { render } from "./circleCom.vue?vue&type=template&id=210ef6fa&scoped=true&ts=true"
import script from "./circleCom.vue?vue&type=script&lang=ts"
export * from "./circleCom.vue?vue&type=script&lang=ts"

import "./circleCom.vue?vue&type=style&index=0&id=210ef6fa&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210ef6fa"]])

export default __exports__